import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import { Helmet } from 'react-helmet';

const Login = () => {
  const { login } = useAuth();
  const { t, switchLanguage, language } = useLanguage();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  // Force French for admin login
  useEffect(() => {
    if (language !== 'fr') {
      switchLanguage('fr');
    }
  }, [language, switchLanguage]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(formData.email, formData.password);
    
    if (result.success) {
      toast.success('Connexion réussie');
      navigate('/admin/dashboard');
    } else {
      toast.error(result.error || 'Échec de la connexion');
    }
    
    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen bg-[#FDFCF8] flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="bg-white border border-stone-100 shadow-xl rounded-2xl p-8">
            <div className="text-center mb-8">
              <img src="/logo.jpg" alt="AILE" className="h-16 w-auto mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-slate-900">{t.admin.login}</h1>
            </div>

            <form onSubmit={handleSubmit} data-testid="login-form">
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    {t.admin.email}
                  </label>
                  <Input
                    data-testid="login-email"
                    type="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    className="bg-white border-stone-200 focus:border-[#127abb] focus:ring-2 focus:ring-[#127abb]/20 rounded-lg h-12"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    {t.admin.password}
                  </label>
                  <Input
                    data-testid="login-password"
                    type="password"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    required
                    className="bg-white border-stone-200 focus:border-[#127abb] focus:ring-2 focus:ring-[#127abb]/20 rounded-lg h-12"
                  />
                </div>

                <Button
                  data-testid="login-submit-btn"
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#127abb] hover:bg-[#0e6292] text-white rounded-full py-6"
                >
                  {loading ? 'Chargement...' : t.admin.loginButton}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;